import { apiSlice } from 'store/slices/api/api-slice';
import {
    EditAvatarResponse,
    NewAvatarRequest,
} from 'types/avatar-system/avatar-system';

export const editAvatarApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        editAvatar: builder.mutation<void, NewAvatarRequest>({
            query: (newAvatarRequest: NewAvatarRequest) => ({
                url: `/avatar/update-avatar/${newAvatarRequest.avatarId}`,
                method: 'PUT',
                body: { ...newAvatarRequest },
            }),
        }),

        getAvatarData: builder.query<EditAvatarResponse, string>({
            query: (params: string) => ({
                url: `/avatar/avatar-info/${params}`,
                method: 'GET',
            }),
        }),
    }),
});

export const { useEditAvatarMutation, useGetAvatarDataQuery } = editAvatarApi;
